import { defineMessage } from '@lingui/macro';

export const regions1 = [
    {
        'id': 100,
        'name': defineMessage({ message: 'Адлер' }),
        'lon': 39.92535644550149,
        'lat': 43.427332694541334,
        'country': 'Russia',
    },
    {
        'id': 971,
        'name': defineMessage({ message: 'Альметьевск' }),
        'lon': 52.29723,
        'lat': 54.901171,
        'country': 'Russia',
    },
    {
        'id': 21,
        'name': defineMessage({ message: 'Анапа' }),
        'lon': 37.316367,
        'lat': 44.894818,
        'country': 'Russia',
    },
    {
        'id': 998,
        'name': defineMessage({ message: 'Архангельск' }),
        'lon': 40.515762,
        'lat': 64.539911,
        'country': 'Russia',
    },
    {
        'id': 1017,
        'name': defineMessage({ message: 'Барнаул' }),
        'lon': 83.776856,
        'lat': 53.346785,
        'country': 'Russia',
    },
    {
        'id': 2145,
        'name': defineMessage({ message: 'Благовещенск' }),
        'lon': 127.553278,
        'lat': 50.249266,
        'country': 'Russia',
    },
    {
        'id': 15,
        'name': defineMessage({ message: 'Великий Новгород' }),
        'lon': 31.269816,
        'lat': 58.522857,
        'country': 'Russia',
    },
    {
        'id': 133,
        'name': defineMessage({ message: 'Владивосток' }),
        'lon': 131.885494,
        'lat': 43.115542,
        'country': 'Russia',
    },
    {
        'id': 28,
        'name': defineMessage({ message: 'Владикавказ' }),
        'lon': 44.681771,
        'lat': 43.024616,
        'country': 'Russia',
    },
    {
        'id': 1864,
        'name': defineMessage({ message: 'Владимир' }),
        'lon': 40.406635,
        'lat': 56.129057,
        'country': 'Russia',
    },
    {
        'id': 11,
        'name': defineMessage({ message: 'Волгоград' }),
        'lon': 44.516975,
        'lat': 48.707067,
        'country': 'Russia',
    },
    {
        'id': 76,
        'name': defineMessage({ message: 'Воронеж' }),
        'lon': 39.1915895697899,
        'lat': 51.67734836348296,
        'country': 'Russia',
    },
    {
        'id': 70,
        'name': defineMessage({ message: 'Екатеринбург' }),
        'lon': 60.58848845221566,
        'lat': 56.82762981801592,
        'country': 'Russia',
    },
    {
        'id': 6,
        'name': defineMessage({ message: 'Ижевск' }),
        'lon': 53.188062,
        'lat': 56.845081,
        'country': 'Russia',
    },
    {
        'id': 74,
        'name': defineMessage({ message: 'Иннополис' }),
        'lon': 48.74349419102039,
        'lat': 55.745889854816994,
        'country': 'Russia',
    },
    {
        'id': 138,
        'name': defineMessage({ message: 'Иркутск' }),
        'lon': 104.280606,
        'lat': 52.289588,
        'country': 'Russia',
    },
    {
        'id': 2363,
        'name': defineMessage({ message: 'Йошкар-Ола' }),
        'lon': 47.886178,
        'lat': 56.6316,
        'country': 'Russia',
    },
    {
        'id': 72,
        'name': defineMessage({ message: 'Казань' }),
        'lon': 49.16768416116135,
        'lat': 55.79482955595611,
        'country': 'Russia',
    },
    {
        'id': 135,
        'name': defineMessage({ message: 'Калининград' }),
        'lon': 20.510137,
        'lat': 54.710162,
        'country': 'Russia',
    },
    {
        'id': 83,
        'name': defineMessage({ message: 'Калуга' }),
        'lon': 36.27836498555936,
        'lat': 54.53830061539347,
        'country': 'Russia',
    },
    {
        'id': 496,
        'name': defineMessage({ message: 'Кемерово' }),
        'lon': 86.086847,
        'lat': 55.355198,
        'country': 'Russia',
    },
    {
        'id': 2146,
        'name': defineMessage({ message: 'Комсомольск-на-Амуре' }),
        'lon': 137.008685,
        'lat': 50.550055,
        'country': 'Russia',
    },
    {
        'id': 232,
        'name': defineMessage({ message: 'Красная Поляна' }),
        'lon': 40.25363857527074,
        'lat': 43.686384525280005,
        'country': 'Russia',
    },
    {
        'id': 80,
        'name': defineMessage({ message: 'Краснодар' }),
        'lon': 38.9783548963033,
        'lat': 45.04585237993574,
        'country': 'Russia',
    },
    {
        'id': 81,
        'name': defineMessage({ message: 'Красноярск' }),
        'lon': 92.87147409229667,
        'lat': 56.02523586302218,
        'country': 'Russia',
    },
    {
        'id': 18,
        'name': defineMessage({ message: 'Липецк' }),
        'lon': 39.599229,
        'lat': 52.608826,
        'country': 'Russia',
    },
    {
        'id': 969,
        'name': defineMessage({ message: 'Магнитогорск' }),
        'lon': 58.980291,
        'lat': 53.407163,
        'country': 'Russia',
    },
    {
        'id': 2816,
        'name': defineMessage({ message: 'Миасс' }),
        'lon': 60.109599,
        'lat': 55.050432,
        'country': 'Russia',
    },
    {
        'id': 166,
        'name': defineMessage({ message: 'Москва' }),
        'lon': 37.61956716563949,
        'lat': 55.73146877838178,
        'country': 'Russia',
    },
    {
        'id': 997,
        'name': defineMessage({ message: 'Мурманск' }),
        'lon': 33.048633,
        'lat': 68.964319,
        'country': 'Russia',
    },
    {
        'id': 2815,
        'name': defineMessage({ message: 'Нефтекамск' }),
        'lon': 54.247751,
        'lat': 56.088483,
        'country': 'Russia',
    },
    {
        'id': 2368,
        'name': defineMessage({ message: 'Нефтеюганск' }),
        'lon': 72.616403,
        'lat': 61.088255,
        'country': 'Russia',
    },
    {
        'id': 967,
        'name': defineMessage({ message: 'Нижневартовск' }),
        'lon': 76.558902,
        'lat': 60.938545,
        'country': 'Russia',
    },
    {
        'id': 976,
        'name': defineMessage({ message: 'Нижнекамск' }),
        'lon': 51.819712,
        'lat': 55.637576,
        'country': 'Russia',
    },
    {
        'id': 77,
        'name': defineMessage({ message: 'Нижний Новгород' }),
        'lon': 43.97091953800959,
        'lat': 56.28816012529134,
        'country': 'Russia',
    },
    {
        'id': 1007,
        'name': defineMessage({ message: 'Новокузнецк' }),
        'lon': 87.136053,
        'lat': 53.757553,
        'country': 'Russia',
    },
    {
        'id': 20,
        'name': defineMessage({ message: 'Новороссийск' }),
        'lon': 37.77867502026246,
        'lat': 44.71187883520463,
        'country': 'Russia',
    },
    {
        'id': 233,
        'name': defineMessage({ message: 'Новосибирск-Академ' }),
        'lon': 83.05364721944571,
        'lat': 54.84983520492382,
        'country': 'Russia',
    },
    {
        'id': 331,
        'name': defineMessage({ message: 'Новосибирск' }),
        'lon': 82.94667850267237,
        'lat': 55.02525181296194,
        'country': 'Russia',
    },
    {
        'id': 134,
        'name': defineMessage({ message: 'Омск' }),
        'lon': 73.368221,
        'lat': 54.989347,
        'country': 'Russia',
    },
    {
        'id': 498,
        'name': defineMessage({ message: 'Оренбург' }),
        'lon': 55.096964,
        'lat': 51.768205,
        'country': 'Russia',
    },
    {
        'id': 1,
        'name': defineMessage({ message: 'Пермь' }),
        'lon': 56.23531133266198,
        'lat': 57.99968259135422,
        'country': 'Russia',
    },
    {
        'id': 67,
        'name': defineMessage({ message: 'Ростов-на-Дону' }),
        'lon': 39.739056996472954,
        'lat': 47.24732226441252,
        'country': 'Russia',
    },
    {
        'id': 795,
        'name': defineMessage({ message: 'Рязань' }),
        'lon': 39.741917,
        'lat': 54.629565,
        'country': 'Russia',
    },
    {
        'id': 78,
        'name': defineMessage({ message: 'Самара' }),
        'lon': 50.18638951842926,
        'lat': 53.22379422760416,
        'country': 'Russia',
    },
    {
        'id': 68,
        'name': defineMessage({ message: 'Санкт-Петербург' }),
        'lon': 30.35312152110487,
        'lat': 59.9424311525066,
        'country': 'Russia',
    },
    {
        'id': 9,
        'name': defineMessage({ message: 'Саратов' }),
        'lon': 46.034266,
        'lat': 51.533562,
        'country': 'Russia',
    },
    {
        'id': 73,
        'name': defineMessage({ message: 'Сочи' }),
        'lon': 39.735218617711524,
        'lat': 43.592304976117035,
        'country': 'Russia',
    },
    {
        'id': 24,
        'name': defineMessage({ message: 'Ставрополь' }),
        'lon': 41.96911,
        'lat': 45.043317,
        'country': 'Russia',
    },
    {
        'id': 2365,
        'name': defineMessage({ message: 'Стерлитамак' }),
        'lon': 55.930825,
        'lat': 53.630403,
        'country': 'Russia',
    },
    {
        'id': 965,
        'name': defineMessage({ message: 'Сургут' }),
        'lon': 73.393032,
        'lat': 61.241778,
        'country': 'Russia',
    },
    {
        'id': 2364,
        'name': defineMessage({ message: 'Сызрань' }),
        'lon': 48.474611,
        'lat': 53.155669,
        'country': 'Russia',
    },
    {
        'id': 136,
        'name': defineMessage({ message: 'Тверь' }),
        'lon': 35.91186,
        'lat': 56.859625,
        'country': 'Russia',
    },
    {
        'id': 7,
        'name': defineMessage({ message: 'Тольятти' }),
        'lon': 49.420411,
        'lat': 53.507852,
        'country': 'Russia',
    },
    {
        'id': 82,
        'name': defineMessage({ message: 'Томск' }),
        'lon': 84.97625496162753,
        'lat': 56.476684482542886,
        'country': 'Russia',
    },
    {
        'id': 69,
        'name': defineMessage({ message: 'Тула' }),
        'lon': 37.606321395448525,
        'lat': 54.1934284730333,
        'country': 'Russia',
    },
    {
        'id': 85,
        'name': defineMessage({ message: 'Тюмень' }),
        'lon': 65.54004072874028,
        'lat': 57.13286952587325,
        'country': 'Russia',
    },
    {
        'id': 1010,
        'name': defineMessage({ message: 'Улан-Удэ' }),
        'lon': 107.584547,
        'lat': 51.834809,
        'country': 'Russia',
    },
    {
        'id': 8,
        'name': defineMessage({ message: 'Ульяновск' }),
        'lon': 48.403132,
        'lat': 54.314192,
        'country': 'Russia',
    },
    {
        'id': 79,
        'name': defineMessage({ message: 'Уфа' }),
        'lon': 56.01605100707184,
        'lat': 54.75805437901069,
        'country': 'Russia',
    },
    {
        'id': 4,
        'name': defineMessage({ message: 'Хабаровск' }),
        'lon': 135.071917,
        'lat': 48.480229,
        'country': 'Russia',
    },
    {
        'id': 687,
        'name': defineMessage({ message: 'Чебоксары' }),
        'lon': 47.247728,
        'lat': 56.139918,
        'country': 'Russia',
    },
    {
        'id': 71,
        'name': defineMessage({ message: 'Челябинск' }),
        'lon': 61.348156620800154,
        'lat': 55.17804188298386,
        'country': 'Russia',
    },
    {
        'id': 2003,
        'name': defineMessage({ message: 'Череповец' }),
        'lon': 37.903443,
        'lat': 59.122672,
        'country': 'Russia',
    },
    {
        'id': 1008,
        'name': defineMessage({ message: 'Чита' }),
        'lon': 113.501049,
        'lat': 52.033635,
        'country': 'Russia',
    },
    {
        'id': 2037,
        'name': defineMessage({ message: 'Южно-Сахалинск' }),
        'lon': 142.729587,
        'lat': 46.957771,
        'country': 'Russia',
    },
    {
        'id': 1009,
        'name': defineMessage({ message: 'Якутск' }),
        'lon': 129.732178,
        'lat': 62.027221,
        'country': 'Russia',
    },
    {
        'id': 13,
        'name': defineMessage({ message: 'Ярославль' }),
        'lon': 39.893813,
        'lat': 57.626559,
        'country': 'Russia',
    },
    {
        'id': 31,
        'name': defineMessage({ message: 'Минск' }),
        'lon': 27.561831,
        'lat': 53.902284,
        'country': 'Belarus',
    },
    {
        'id': 37,
        'name': defineMessage({ message: 'Алматы' }),
        'lon': 76.945627,
        'lat': 43.237163,
        'country': 'Kazakhstan',
    },
    {
        'id': 39,
        'name': defineMessage({ message: 'Астана' }),
        'lon': 71.43042,
        'lat': 51.128207,
        'country': 'Kazakhstan',
    },
].sort((a, b) => (a.name.id > b.name.id) ? 1 : ((b.name.id > a.name.id) ? -1 : 0));

export const regions2 = [
    {
        'id': 1543,
        'name': defineMessage({ message: 'Порту-Алегри' }),
        'lon': -51.191882,
        'lat': -30.030725,
        'country': 'Brazil',
    },
    {
        'id': 1051,
        'name': defineMessage({ message: 'Рио-де-Жанейро' }),
        'lon': -43.18913,
        'lat': -22.905722,
        'country': 'Brazil',
    },
    {
        'id': 1050,
        'name': defineMessage({ message: 'Сан-Па́улу' }),
        'lon': -46.636972,
        'lat': -23.544279,
        'country': 'Brazil',
    },
    {
        'id': 1161,
        'name': defineMessage({ message: 'Флорианополис' }),
        'lon': -48.618189,
        'lat': -27.581393,
        'country': 'Brazil',
    },
    {
        'id': 1612,
        'name': defineMessage({ message: 'Фортале́за' }),
        'lon': -38.525167,
        'lat': -3.730933,
        'country': 'Brazil',
    },
    {
        'id': 1934,
        'name': defineMessage({ message: 'Консепсьон' }),
        'lon': -73.044601,
        'lat': -36.819689,
        'country': 'Chile',
    },
    {
        'id': 798,
        'name': defineMessage({ message: 'Сантьяго' }),
        'lon': -70.653422,
        'lat': -33.445255,
        'country': 'Chile',
    },
    {
        'id': 2106,
        'name': defineMessage({ message: 'Сапопан' }),
        'lon': -103.391616,
        'lat': 20.721175,
        'country': 'Mexico',
    },
    {
        'id': 1084,
        'name': defineMessage({ message: 'Лима' }),
        'lon': -77.030563,
        'lat': -12.046025,
        'country': 'Peru',
    },
    {
        'id': 1899,
        'name': defineMessage({ message: 'Темуко' }),
        'lon': -72.60281,
        'lat': -38.738697,
        'country': 'Peru',
    },
].sort((a, b) => (a.name.id > b.name.id) ? 1 : ((b.name.id > a.name.id) ? -1 : 0));

export const regions = regions1.concat(regions2);
